import api from "src/api/index";
import {STATE_MEDIA} from "src/config";

export async function getLlwHints(){
    try {
        const response =  await api.get(STATE_MEDIA + "api/dashboard/hints-llw")
        return response.data?.items ?? []
    } catch (error) {
        console.error("ошибка загрузки статей", error?.message)
    }
}

